import { render, staticRenderFns } from "./alertDetailPop.vue?vue&type=template&id=1bf00e28&scoped=true"
import script from "./alertDetailPop.vue?vue&type=script&setup=true&lang=js"
export * from "./alertDetailPop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./alertDetailPop.vue?vue&type=style&index=0&id=1bf00e28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf00e28",
  null
  
)

export default component.exports